import { ArrowRight } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import CheckboxChecked from 'assets/CheckboxChecked';
import { CheckboxUnchecked } from 'assets/CheckboxUnchecked';
import { SearchBar, SearchContainer, StyledInputBase } from 'core/components/global/advanceSearch/advanceSearch.styled';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { fetchBaseUrl } from 'core/utils/common';

type Conversation = {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  user_id: string | null;
  is_active: boolean;
  message_count: number;
  metadata: any;
};

type FullHistoryPanelProps = {
  isOpen: boolean;
  onClose: () => void;
  conversations: Conversation[];
  apptheme: any;
  onSelectConversation: (conversationId: string) => void;
  fetchConversations: () => void;
}

const baseURL = fetchBaseUrl({port: 8000});

export default function FullHistoryPanel({ isOpen, onClose, conversations , apptheme, onSelectConversation, fetchConversations}: FullHistoryPanelProps) {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const toggleSelect = (id: string) => {
        setSelectedIds(prev =>
            prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
        );
    };

    const selectAll = () => setSelectedIds(conversations.map(c => c.id));
    const cancelSelection = () => setSelectedIds([]);
    
    const deleteSelected = async () => {
        for (const id of selectedIds) {
            try {
            await fetch(`${baseURL}/socai/api/conversation/${id}`, {
                method: "DELETE",
                headers: {
                "X-API-Key": "dev-key"
                }
            });
             await fetch(`${baseURL}/socai/api/clear-file/${id}`, {
                method: "DELETE",
                headers: {
                "X-API-Key": "dev-key"
                }
            });
            } catch (err) {
            console.error(`Failed to delete conversation ${id}`, err);
            }
        }
        // Optionally, refresh the conversation list or remove deleted from UI
        setIsDeleting(false);
        setShowConfirm(false);
        setSelectedIds([]);
        fetchConversations();
        };

    const setConversationFromHistory = (conversationId: string) => {
        onSelectConversation(conversationId);
    };

    const filtered = conversations.filter(c =>
        c.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const theme = useTheme();

    if (!isOpen) return null;

    
    return (
        <div className={` ${apptheme.name === "dark-theme" ? "text-white !important" : "text-black"} w-[50vw] m-auto justify-center`}>
            {showConfirm && (
                <div className="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-[#222] p-8 rounded-2xl shadow-2xl flex flex-col items-center min-w-[340px]">
                    <div className="text-xl font-bold mb-2 text-center text-black dark:text-white">
                        Delete Chat
                    </div>
                    <div className="mb-6 text-center dark:text-gray-600 text-base">
                        Once deleted, conversations cannot be restored.
                    </div>
                    <div className="flex gap-4 justify-center w-full">
                        <button
                        className="px-6 py-2 rounded border border-blue-500 text-blue-600 font-medium bg-white hover:bg-blue-50 transition"
                        onClick={() => setShowConfirm(false)}
                        disabled={isDeleting}
                        >
                        Cancel
                        </button>
                        <button
                        className="px-6 py-2 rounded bg-red-600 hover:bg-red-700 text-white font-medium transition"
                        onClick={deleteSelected}
                        disabled={isDeleting}
                        >
                        {isDeleting ? "Deleting..." : "Delete"}
                        </button>
                    </div>
                    </div>
                </div>
                )}
            <div className="flex justify-between">
                <h2 className="text-xl font-bold mb-4">Your chat history</h2>
                <CloseIcon className="me-2 cursor-pointer" onClick={onClose} />
                
            </div>
            {/* <div className="relative mb-4">
                <input
                    type="text"
                    placeholder="Search your chats..."
                    style={{
                    boxShadow: 'inset 1px 0.5px 2.2px hsl(0deg 0% 0% / 0.3)',
                    backgroundColor: '#ffffff',
                    }}
                    className={`w-full ${apptheme.name === "dark-theme" ? " bg-[#1e293b] !important text-white" : "text-black"} px-4 py-2 rounded-[25px] outline-none pr-10`}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                        onClick={() => setSearchTerm('')}
                        tabIndex={-1}
                        aria-label="Clear search"
                    >
                    ×
                    </button>
                )}
                </div> */}

                <SearchContainer className="w-100">
                    <SearchBar>
                        <StyledInputBase
                        placeholder="Search your chats..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </SearchBar>
        
                    {/* Clear and search icon */}
                    <CloseIcon className="me-2 cursor-pointer" onClick={() => setSearchTerm('')} />
                </SearchContainer>

            <div className="flex justify-end mt-2 mb-2 gap-3">
                <Button onClick={selectAll}>
                    Select all
                </Button>
                <Button onClick={cancelSelection}>
                    Cancel
                </Button>
                <button
                    onClick={() => setShowConfirm(true)}
                    className="bg-red-600 text-white px-4 py-1 rounded hover:bg-red-700"
                    disabled={selectedIds.length === 0 || isDeleting}
                >
                    Delete
                </button>
            </div>

            <div className="overflow-y-auto pr-1 space-y-2">
                {filtered.map((convo) => (
                    <div style={{
                              border: "1px solid",
                              borderColor: selectedIds.includes(convo.id) ? "#6495ed" : "#464646",
                              overflow: "visible",
                            }}
                            className={`flex d-flex justify-content-between cursor-pointer flex-row rounded-xl ${apptheme.name === "dark-theme" ? " hover:bg-[#1e293b] !important" : "hover:bg-purple-100 "}`}>
                        <div
                            key={convo.id}
                            
                            onClick={() => toggleSelect(convo.id)}
                            className={`flex-1 py-3 px-4 d-flex justify-content-start flex-column transition
                                }`}
                        >
                            <div className="flex items-center gap-3">
                                <label
                                    style={{ display: "inline-flex", alignItems: "center", gap: "8px", cursor: "pointer", marginBottom: "0.5rem" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedIds.includes(convo.id)}
                                        onChange={() => toggleSelect(convo.id)}
                                        style={{ display: "none" }}
                                    />
                                    <span style={{ height: "14px", display: "contents" }}>
                                        <div style={{ transform: "scale(0.75)" }}>
                                            {selectedIds.includes(convo.id) ? <CheckboxChecked /> : <CheckboxUnchecked theme={theme} />}
                                        </div>
                                    </span>
                                </label>
                                <div>
                                    <div className="font-medium">{convo.title}</div>
                                    <div className="text-sm text-gray-400">
                                        {new Date(convo.updated_at).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex py-3 px-4 justify-content-end align-items-center flex-row">
                            <IconButton
                                aria-label="send prompt"
                                edge="end"
                                onClick={() => {
                                    onSelectConversation(convo.id); // fetch messages
                                    onClose(); // hide history panel
                                }}
                                >
                                <ArrowRight />
                            </IconButton>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};